<div class="profile-management">
  <span class="profile-badge" *ngIf="config.showBadge && !config.badgeOnRight" (click)="viewUserDetails()">
    <span>{{ user | userInitials }}</span>
  </span>
  <div class="name-links" [ngClass]="{'with-badge': config.showBadge,'rightAlignText': displayLicence}">
    <p *ngIf="!config.showLogout" class="profile-name" [ngClass]="{'link': canViewUserDetails}" (click)="viewUserDetails()">{{displayName}}</p>
    <p *ngIf="config.showLogout" [ngClass]="{'hugeName': displayLicence}"  class="profile-name">{{displayName}}</p>
    <p *ngIf="config.showUserName" class="links font-size-small truncate">{{userName}}</p>
    <p *ngIf="user?.userDisabled || deletedUser" class="font-size-small text-danger">{{userStatus | translate}}</p>
    <p *ngIf="config.showLogout" class="links">
      <a (click)="viewUserDetails()">{{'$header_profile' | translate}}</a> | 
      <a (click)="logout()" [attr.tabindex]="0" [innerHTML]="'$profile_user_logout' | translate"></a>
    </p>
  </div>
  <span class="profile-badge-right" *ngIf="config.showBadge && config.badgeOnRight">
    <span>{{ user | userInitials }}</span>
  </span>
</div>
